import { render, staticRenderFns } from "./SellerOrderDetail.vue?vue&type=template&id=5b65adb6&scoped=true&"
import script from "./SellerOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SellerOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SellerOrderDetail.vue?vue&type=style&index=0&id=5b65adb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65adb6",
  null
  
)

export default component.exports